/* eslint-disable */
import { FC, useState, useEffect } from 'react';
import RChart from 'react-chartjs-2';
import { Chart } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import _ from 'lodash';

import { bubbleChartOptions } from '../../utilities/chartUtils';
import { ChartSkeleton } from '../ChartSkeleton/ChartSkeleton';
import { Title, NoData, FilterSlot } from '../ChartSkeleton/styles';
import { ChartData, ChartOptions, DefaultDataPoint } from 'chart.js';
import { ScalableBubbleChart } from '../../chartPlugins/ScalableBubbleChart';
import { useBubbleChartProportions } from './useBubbleChartProportions';

Chart.register(/* BarWithErrorBarsController, BarWithErrorBar, */ Annotation, ScalableBubbleChart);

export type ChartProps = {
  id: string;
  data: ChartData<'scalableBubble', DefaultDataPoint<'scalableBubble'>, string | undefined>;
  title?: string;
  bubbleKey?: string;
  colors?: string[];
  options?: ChartOptions<'scalableBubble'>;
  loading?: boolean;
  footer?: JSX.Element;
  filterSlot?: JSX.Element;
  isPreview?: boolean;
  chartTitle?: string;
  aspectRatio?: number;
};

export const BubbleChart: FC<ChartProps> = ({
  id,
  data,
  title,
  bubbleKey,
  options = bubbleChartOptions,
  filterSlot,
  footer,
  loading,
  isPreview,
  chartTitle,
  aspectRatio,
}) => {
  const hasData = data.datasets
    .filter(Boolean)
    .some((d) => d.data?.some((p) => p.y && p.x && (p as any).size));

  const [width, height] = useBubbleChartProportions();
  const [redrawBubbleChart, setRedrawBubbleChart] = useState(true);

  useEffect(() => {
    setRedrawBubbleChart(false);
    setTimeout(() => {
      setRedrawBubbleChart(true);
    }, 10);
  }, [aspectRatio]);

  return (
    <ChartSkeleton
      loading={loading}
      id={id}
      isPreview={isPreview}
      chartTitle={chartTitle}
      title={
        <>
          {filterSlot && <FilterSlot>{filterSlot}</FilterSlot>}
          {title && <Title>{title}</Title>}
        </>
      }
      footer={hasData ? footer : undefined}
    >
      {!hasData && <NoData>No Data</NoData>}
      {hasData && redrawBubbleChart && (
        <div className={`flex justify-center w-full min-h-[300px]`}>
          <RChart
            type="scalableBubble"
            // key={width}
            options={options as any}
            data={data}
            redraw
            width={isPreview ? window.innerHeight * 0.5 * (aspectRatio || 1) : width}
            height={isPreview ? window.innerHeight * 0.5 : height}
          />
        </div>
      )}
    </ChartSkeleton>
  );
};
